<template>
  <v-list-tile
    class="user-block white--text curson-pointer my-0"
    :class="{'only-avatar': showOnlyAvatar}"
    style="margin-bottom: calc(var(--safe-area-inset-bottom)) !important;"
  >
    <template
      v-if="user"
    >
      <v-menu
        top
        offset-y
        left
        content-class="userblock-dropdown"
        transition="slide-y-transition"
        nudge-bottom
      >
        <template v-slot:activator="{ on }" v-if="showOnlyAvatar">
          <v-list-tile-avatar
            size="30"
            v-on="on"
            color="primary"
            class="mx-1 cursor-pointer"
          >
            <span>{{ user && user.firstName ? user.firstName.substring(0,1) : '' }}{{ user && user.lastName ? user.lastName.substring(0,1) : '' }}</span>
          </v-list-tile-avatar>
        </template>
        <template v-slot:activator="{ on }" v-else>
          <sidebar-item
            :size="30"
            custom-classes="cursor-pointer"
            :color="isForBizgain ? 'white' : 'primary'"
            :hide-avatar="showOnlyAvatar"
            :hide-content="showOnlyAvatar"
          >
            <template v-slot:avatar>
              <v-list-tile-avatar
                size="30"
                v-on="on"
                color="primary cursor-pointer"
                v-if="showOnlyAvatar"
                class="mx-1"
              >
                <span>{{ user && user.firstName ? user.firstName.substring(0,1) : '' }}{{ user && user.lastName ? user.lastName.substring(0,1) : '' }}</span>
              </v-list-tile-avatar>
              <span v-on="on" v-else :class="{ 'primary--text' : isForBizgain }">{{ user && user.firstName ? user.firstName.substring(0,1) : '' }}{{ user && user.lastName ? user.lastName.substring(0,1) : '' }}</span>
            </template>
            <template v-slot:content v-if="!showOnlyAvatar">
              <v-list-tile-title v-on="on">
                <v-list-tile-title>{{ user.firstName }} {{ user.lastName }}</v-list-tile-title>
              </v-list-tile-title>
            </template>
          </sidebar-item>
        </template>
        <div class="dropdown-content">
          <v-list id="user-menu" class="dropdown-list">
            <template>
              <v-list-tile @click="forwardToUserPreference">
                <v-list-tile-action>
                  <v-icon>mdi-cog</v-icon>
                </v-list-tile-action>
                <v-list-tile-content class="cursor-pointer">
                  <v-list-tile-title>{{ $t('message.userPreferences') }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
            <logout />
          </v-list>
        </div>
      </v-menu>
    </template>
  </v-list-tile>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import {
  VList,
  VListTile,
  VListTileAvatar,
  VListTileTitle,
  VListTileContent,
  VListTileAction,
  VDivider,
  VIcon,
  VMenu
} from 'vuetify/lib';
import SidebarItem from 'Components/Sidebar/SidebarItem';
import { AppService } from 'AppServices/appService';
import Logout from './Logout';

export default {
  components: {
    VList,
    VListTile,
    VListTileAvatar,
    VListTileTitle,
    VMenu,
    SidebarItem,
    VList,
    VListTileAvatar,
    VListTileTitle,
    VMenu,
    VListTileContent,
    VListTileAction,
    VIcon,
    Logout,
    SidebarItem
  },
  props: {
    showOnlyAvatar: {
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'portal',
      'isForBizgain',
      'businessProfileId'
    ])
  },
  async created() {
    // if user is signed in and if id is not set, then fetch the details of the user
    // if id is set then it means that the user was already fetched and the data is available
    if (this.user && this.user.isSignedIn && !this.user.id)
      await this.fetchUser();
  },
  methods: {
    ...mapActions(['setUser']),
    async fetchUser() {
      var user = await getUserData(this.user.emailAddress);
      this.setUser(user);
    },
    forwardToUserPreference(){
      this.$router.push({ name: 'userPreferences' });
    }
  }
};
</script>